<template>
  <el-container class="classManger" id="print">
    <el-aside class="sidebar" v-if="testProject.length>0">
      <div class="header-title">{{captureRecordObj.name}}-{{captureRecordObj.mobile}}</div>
      <div class="title" v-if="queryObj.subjectName">{{queryObj.subjectName}}</div>
      <div class="campusManage-search">
        <div class="btn_left" v-for="(item, index) in testProject" :key="index">
          <div :class="index==curIdx?'switch-tab sitch-active':'switch-tab'" @click.stop="clickBtn(item,index)">
            <span>{{item.courseName}}&nbsp;&nbsp;&nbsp;{{item.captureNum}}</span>
            <i v-if="item.approvalState==1" class="el-icon-circle-check" style="color:#24D2B5;float:right;"></i>
            <i v-else class="el-icon-circle-close" style="color:#FF7AB4;float:right;"></i>
          </div>
        </div>
      </div>
    </el-aside>
    <el-main class="sidebarRight" :key="captureRecordObj.cardFrontPicUrl">
      <el-card>
        <el-row :gutter="20">
          <el-col :sm="10" :md="5" :lg="9">
            <span>身份证</span>
            <p class="identyCard">
              <img :src="captureRecordObj.cardFrontPicUrl">
              <img :src="captureRecordObj.cardBackPicUrl">
            </p>
          </el-col>
          <el-col :sm="10" :md="5" :lg="7">
            <span>证件照</span>
            <p>
              <img :src="captureRecordObj.threeMonthPicUrl" class="credictCard">
            </p>
          </el-col>
          <el-col :sm="10" :md="5" :lg="8">
            <div class="shadow-box" v-if="campusList[0]">
              <p class="textColor">
                <label>审核人 </label>
                <span> {{captureRecordObj.approvalName}}</span>
              </p>
              <p class="textColor">
                <label>审核时间</label>
                <span>{{captureRecordObj.approvalTime}}</span>
              </p>
              <p class="textColor">
                <label>审核结果</label>
                <span v-if="captureRecordObj.approvalState == 1">通过</span>
                <span v-if="captureRecordObj.approvalState == 2">不通过</span>
              </p>
            </div>
          </el-col>
        </el-row>
        <div class="body_content">
          <p>当前抓拍记录({{captureRecordList.length}})</p>
          <div class="pic-box">
            <img v-for="(item,index) in captureRecordList" :key="index" :src="item.url" class="certificatePic">
          </div>
          <p v-if="captureRecordList.length>0">
            <el-button type="danger" @click.stop="nopass">不通过</el-button>
            <el-button type="primary" @click.stop="pass">通过</el-button>
          </p>
        </div>
        <div style="clear:both;"></div>
      </el-card>
    </el-main>
  </el-container>
</template>
<script>
import { uploadTC } from "../../upload/tecent";
import axios from "axios";
import { uploadOSS } from "../../upload/upload";
export default {
  data () {
    return {
      queryObj: {},
      captureRecordObj: {},
      curIdx: 0,
      showAbbreviationName: false,
      id: "", //校区id
      showEditorDialog: false,
      showAddDialog: false,
      loading: true, //表格是否加载中
      inp: "", //输入框绑定的值
      defaultProps: {
        children: "list",
        label: "name"
      },
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      campusShow: false,
      NodeClick: true,
      addCampusDialog: false,
      editCampusDialog: false,
      addwidth: "30%",

      campusId: null,
      start: "",
      end: "",
      total: 0,
      addAttachmentPhotoBlock: false,
      updateAttachmentBlock: false,
      updateFodderGroupInfoBlock: false,
      loading: false,
      subjectExam: {
        typeId: '',
        studentId: ''
      },
      captureRecord: {
        examinationSettingId: '',
        id: '',
        examinationStudentInfoId: ''
      },
      testCheck: {
        id: "",
        examinationSettingId: '',
        examinationStudentInfoId: '',
        approvalState: 1
      },
      checkProject: {
        checkName: '',
        checkTime: '',
        checkPass: ''
      },
      testProject: [],
      testExam: [],
      testRecord: [],
      frontCard: '',
      backCard: '',
      threeCard: '',
      captureRecordList: '',
      campusList: []
    }
  },
  watch: {
    addCampusDialog: function (newVal) {
      if (!newVal) {
        this.campusShow = false;
        this.$refs.addCampusForm.resetFields();
        this.addCampusForm.parentId = "";
        this.addCampusForm.name = "";
        this.NodeClick = true;
      } else {
      }
    },
    editCampusDialog: function (newVal) {
      if (!newVal) {
        this.campusShow = false;
        this.$refs.editCampusForm.resetFields();
        this.editCampusForm.parentId = "";
        this.editCampusForm.name = "";
        this.NodeClick = true;
      } else {
      }
    }
  },
  created () {
    this.queryObj = this.$route.query
  },
  mounted () {
    let querys = this.$route.query
    console.log(' Number(querys.examinationSettingItemId)', querys.examinationSettingItemId, 0 + querys.examinationSettingItemId)
    this.subjectExam.typeId = querys.examinationSettingItemId
    this.subjectExam.studentId = querys.studentId
    this.captureRecord = {
      examinationSettingId: querys.examinationSettingId,
      id: querys.examinationSettingItemId,
      examinationStudentInfoId: querys.examinationStudentInfoId
    }
    console.log(this.$route.query)
    this.getSubjectGetTest(this.subjectExam)
    // this.getSubjectUploadCaptureRecord(this.captureRecord)
  },
  methods: {
    clickBtn (item, idx) {
      console.log(item, '88888')
      this.curIdx = idx
      this.captureRecord.examinationSettingId = item.examinationSettingId
      this.captureRecord.id = item.id
      this.captureRecord.examinationStudentInfoId = item.examinationStudentInfoId
      console.log(this.captureRecord)
      this.getSubjectUploadCaptureRecord(this.captureRecord)
    },
    //获取考试记录
    getSubjectGetTest (data) {
      this.api.getSubjectGetTest(data).then(result => {
        this.loading = false;
        console.log(result, 'getSubjectGetTest')
        this.testProject = result.data
        if (result.success) {
          this.testProject.forEach((item, index) => {
            if (item.courseName == this.$route.query.courseName) {
              this.curIdx = index;
              this.clickBtn(result.data[this.curIdx], this.curIdx);
            }
          })
          // this.clickBtn(result.data[this.curIdx], this.curIdx)
        }
      }).catch(error => {
        console.log(error)
      })
    },
    //获取抓拍记录
    getSubjectUploadCaptureRecord (data) {
      this.api.getSubjectUploadCaptureRecord(data).then(result => {
        this.captureRecordObj = result.data
        this.frontCard = result.data.cardFrontPicUrl
        this.backCard = result.data.cardBackPicUrl
        this.threeCard = result.data.threeMonthPicUrl
        this.captureRecordList = result.data.attachments || []
        this.checkProject.checkName = result.data.approvalName
        this.checkProject.checkTime = result.data.approvalTime
        this.checkProject.checkPass = result.data.approvalState
        console.log(result.data)
        console.log(this.checkProject)
        console.log(this.captureRecordList.length)
        this.campusList.push(this.checkProject)
      })
        .catch(error => {
          console.log(error)
        })
    },
    //抓拍审批
    getSubjectUploadCaptureApprove (data) {
      this.api.getSubjectUploadCaptureApprove(data).then(result => {
        if (result.code == 200) {
          this.getSubjectGetTest(this.subjectExam)
          this.$message({
            message: '操作成功',
            type: 'success'
          });
        }
      }).catch(error => {
        console.log(error)
      })
    },
    pass () {
      this.testCheck.approvalState = 1
      this.testCheck.id = this.captureRecord.id
      this.testCheck.examinationSettingId = this.captureRecord.examinationSettingId
      this.testCheck.examinationStudentInfoId = this.captureRecord.examinationStudentInfoId
      console.log(this.testCheck)
      this.getSubjectUploadCaptureApprove(this.testCheck)
    },
    nopass () {
      this.testCheck.approvalState = 2
      this.testCheck.id = this.captureRecord.id
      this.testCheck.examinationSettingId = this.captureRecord.examinationSettingId
      this.testCheck.examinationStudentInfoId = this.captureRecord.examinationStudentInfoId
      console.log(this.testCheck)
      this.getSubjectUploadCaptureApprove(this.testCheck)
    }
  },

};
</script>
<style scoped>
.sidebar {
  width: 245px !important;
  border-radius: 4px;
  overflow: auto;
  background: #fff;
}
.sidebarRight {
  padding: 0px 20px !important;
}
.sidebar .title,
.sidebarRight .title {
  height: 30px;
  line-height: 30px;
  padding-left: 20px;
  border-bottom: 1px solid #e5ecf0;
  font-weight: bold;
  color: #999;
}
.header-title {
  height: 30px;
  line-height: 30px;
  padding-left: 20px;
}
.sidebarRight .search {
  background: #66b1ff !important;
  border: 0;
  outline: none;
  border-radius: 0;
  height: 40px;
  color: white !important;
}
.classManger .caret-wrapper {
  position: absolute;
  right: 0;
  top: -5px;
}
.table_bottom {
  margin: 20px 0;
}
.left-top-bottom {
  float: right;
  color: #4d94ff;
  font-weight: 600;
  margin-left: 10px;
  margin-top: 2px;
}
.campusManage-search {
  padding: 0px 10px;
}
.campusManage-tree {
  margin-top: 10px;
}
.span-ellipsis {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
}
.certificatePic {
  width: 22%;
  margin: 10px;
}
.textColor label {
  color: #ccc;
  padding-right: 20px;
  width: 55px;
  display: inline-block;
}
.btn_left {
  width: 100%;
  margin: 10px auto;
  display: block;
}
.btn_left .el-button {
  width: 100%;
  margin-bottom: 10px;
}
.btn_left .el-button + .el-button {
  margin-left: 0px;
}
.credictCard {
  width: 85%;
}
.identyCard {
  display: flex;
  align-content: center;
}
.identyCard img {
  width: 50%;
}
.body_content {
  display: block;
}
.switch-tab {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 8px 35px;
  box-sizing: border-box;
  border: 1px solid #999999;
  cursor: pointer;
  color: #999999;
}
.sitch-active {
  border: 1px solid #66b1ff;
  color: #66b1ff;
}
.shadow-box {
  padding: 35px;
  background: #fafafa;
}
.pic-box {
  width: 100%;
  height: 520px;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/testSystem/candidPhotograph.vue